/**
 * Browser vs-AI matches end after this. Player-facing copy says "one hour"
 * (`duel.overBy.aiTooLong` and the changelog). Change both together.
 */
export const AI_DUEL_MAX_MS = 60 * 60 * 1000
